/* Brochiva, page d accueil. Petit guide de choix, sans dependance. */
(() => {
  'use strict';

  const guide = document.querySelector('[data-bv-guide]');
  if (!guide) return;

  const lien = guide.querySelector('[data-bv-guide-lien]');
  const resume = guide.querySelector('[data-bv-guide-resume]');
  const defaut = guide.dataset.defaut || '/collections/broches';
  const choix = { intention: null, univers: null, budget: null };

  const construire = () => {
    const base = (choix.univers && choix.univers.url) || (choix.intention && choix.intention.url) || defaut;
    const params = new URLSearchParams();
    if (choix.budget) {
      if (choix.budget.min) params.set('filter.v.price.gte', choix.budget.min);
      if (choix.budget.max) params.set('filter.v.price.lte', choix.budget.max);
    }
    const q = params.toString();
    return q ? `${base}?${q}` : base;
  };

  /* Les phrases viennent des reglages de la section, posees en attributs. */
  const textes = {
    depart: (resume && resume.dataset.depart) || 'Choisissez au moins un univers pour voir votre sélection.',
    resultat: (resume && resume.dataset.resultat) || 'Votre sélection : {choix}.',
    offrir: (resume && resume.dataset.offrir) || 'à offrir',
    moi: (resume && resume.dataset.moi) || 'pour vous',
  };

  const phrase = () => {
    if (!choix.univers && !choix.intention && !choix.budget) return textes.depart;
    const bouts = [];
    if (choix.univers) bouts.push(`<strong>${choix.univers.libelle}</strong>`);
    if (choix.intention) bouts.push(choix.intention.valeur === 'offrir' ? textes.offrir : textes.moi);
    if (choix.budget && choix.budget.libelle) bouts.push(choix.budget.libelle.toLowerCase());
    return textes.resultat.replace('{choix}', bouts.join(', '));
  };

  const maj = () => {
    const url = construire();
    if (lien) lien.setAttribute('href', url);
    if (resume) resume.innerHTML = phrase();
  };

  guide.querySelectorAll('.bv-puce').forEach((puce) => {
    puce.addEventListener('click', () => {
      const groupe = puce.dataset.groupe;
      const actif = puce.getAttribute('aria-pressed') === 'true';

      guide.querySelectorAll(`.bv-puce[data-groupe="${groupe}"]`).forEach((autre) => {
        autre.setAttribute('aria-pressed', 'false');
      });

      if (actif) {
        choix[groupe] = null;
      } else {
        puce.setAttribute('aria-pressed', 'true');
        choix[groupe] = {
          valeur: puce.dataset.valeur,
          libelle: puce.textContent.trim(),
          url: puce.dataset.url || null,
          min: puce.dataset.min || null,
          max: puce.dataset.max || null,
        };
      }
      maj();
    });
  });

  maj();
})();
